import type {
  RunDomainEvent,
  RunDomainEventFilter,
} from '@web/lib/runEvents/types';

type Listener = (event: RunDomainEvent) => void;

function matches(filter: RunDomainEventFilter, event: RunDomainEvent): boolean {
  return (
    (!filter.projectId || filter.projectId === event.projectId) &&
    (!filter.runId || filter.runId === event.runId) &&
    (!filter.eventTypes || filter.eventTypes.includes(event.eventType)) &&
    (!filter.categories || filter.categories.includes(event.category)) &&
    (!filter.deliveryModes || filter.deliveryModes.includes(event.deliveryMode))
  );
}

export class RunDomainEventHub {
  private sequence = 0;
  private readonly listeners = new Map<
    number,
    { filter: RunDomainEventFilter; listener: Listener }
  >();

  subscribe(filter: RunDomainEventFilter, listener: Listener): () => void {
    const id = ++this.sequence;
    this.listeners.set(id, { filter, listener });
    return () => this.listeners.delete(id);
  }

  publish(event: RunDomainEvent): void {
    for (const subscription of [...this.listeners.values()]) {
      if (!matches(subscription.filter, event)) continue;
      try {
        subscription.listener(event);
      } catch (error) {
        console.error('[RunDomainEventHub] listener failed', error);
      }
    }
  }

  listenerCount(): number {
    return this.listeners.size;
  }

  clear(): void {
    this.listeners.clear();
  }
}

export const runDomainEventHub = new RunDomainEventHub();
